import { CollaborationResult } from '@descomplica/microfrontend-core';

export const INFRASTRUCTURE_ERROR_IDENTIFIER = 'InfrastructureError';
export const INFRASTRUCTURE_ERROR_MESSAGE = 'Ocorreu um erro tentando conectar com o servidor';

export class InfrastructureError extends CollaborationResult<any> {
  constructor(error: any) {
    super(INFRASTRUCTURE_ERROR_IDENTIFIER, INFRASTRUCTURE_ERROR_MESSAGE, error);
  }
}
